import Vue from "vue";
import Router from "vue-router";
import NomenuContainer from "@/views/nomenu_container.vue";
import MenuContainer from "@/views/menu_container.vue";
import PageNotFound from "@/views/page_not_found.vue";
import store from "@/plugins/store";

Vue.use(Router);

// lazy load these...

// logon
const LogonForm = () => import("@/views/logon/logon_form.vue");
const Terms = () => import("@/views/logon/terms.vue");
const Upgrade = () => import("@/views/logon/upgrade.vue");

// desktop
const PayrollHeaderTab = () => import("@/views/desktop/payroll_header/payroll_header_tab.vue");
const NewPayrollHeader = () => import("@/views/desktop/payroll_header/new_payroll_header.vue");
const EditPayrollHeader = () => import("@/views/desktop/payroll_header/edit_payroll_header.vue");
const DiaryDialogue = () => import("@/views/desktop/diary/diary_dialogue.vue");
const EditEventDialogue = () => import("@/views/desktop/diary/edit_event.vue");
const EditLeaveDialog = () => import("@/views/desktop/diary/edit_leave.vue");
const EditHolidayDialog = () => import("@/views/desktop/diary/edit_holiday.vue");
const EditTaskDialog = () => import("@/views/desktop/diary/edit_task.vue");
const EditTimesheetDialog = () => import("@/views/desktop/diary/edit_timesheet.vue");
const EditItemDialog = () => import("@/views/desktop/diary/edit_item.vue");
const SubTaskDialog = () => import("@/views/desktop/diary/new_subtask.vue");
const MediaPlan = () => import("@/views/desktop/media/media_planning.vue");
const MediaRadioHolding = () => import("@/views/desktop/media/radio_holdings/media_holding.vue");
const WebClaim = () => import("@/views/desktop/webexpense/webexpense_cliam.vue");

// dashboard/home
const Dashboard = () => import("@/views/dashboard/Dashboard.vue");

// leave
const Leave = () => import("@/views/leave/leave.vue");
const LeaveEdit = () => import("@/views/leave/leave_edit.vue");
const LeaveCalculator = () => import("@/views/leave/leave_calculator.vue");

// expenses
const Expenses = () => import("@/views/expenses/receipts/receipts.vue");
const Claims = () => import("@/views/expenses/claims/claims.vue");
const ManagerReview = () => import("@/views/expenses/approvals/list_approval.vue");
const Finance = ()  => import("@/views/expenses/finance/finance.vue");
const NewClaim = () => import("@/views/expenses/claims/new_claims.vue");
const EditClaim = () => import("@/views/expenses/claims/submit_claims.vue");
const ApproveClaim = () => import("@/views/expenses/approvals/approval_claim_content.vue");
const FinanceClaim = () => import("@/views/expenses/finance/finance_detail.vue");

// jobs
// const SavedJobWorklists = () => import("@/views/jobs/SavedWorklists.vue");
// const JobWorklist = () => import("@/views/jobs/Worklist.vue");
// const SearchJobs = () => import("@/views/jobs/SearchJobs.vue");

const SavedJobWorklists = () => import("@/views/jobs/SavedWorklists_new.vue");
const JobWorklist = () => import("@/views/jobs/Worklist_new.vue");
const SearchJobs = () => import("@/views/jobs/SearchJobs_new.vue");
const CreateNewJob = () => import("@/views/jobs/CreateNewJob.vue");
const Job = () => import("@/views/jobs/Job.vue");

// addressbook
const SavedAbookWorklists = () => import("@/views/addressbook/SavedWorklists.vue");
const AbookWorklist = () => import("@/views/addressbook/Worklist.vue");
const SearchAddressbook = () => import("@/views/addressbook/SearchAddressbook.vue");
const Addressbook = () => import("@/views/addressbook/Addressbook.vue");

// tasks

// const ViewTask = () => import("@/views/tasks/view_task.vue");
// const Tasklist = () => import("@/views/tasks/Tasklist.vue");
const SavedTasklist = () => import("@/views/tasks/SavedTasklists.vue");
const SearchTasks = () => import("@/views/tasks/SearchTasks.vue");
const MyTimesheets = () => import("@/views/timesheets/my_timesheets.vue");

const Tasks = () => import("@/views/tasks/tasks.vue");
const NewTask = () => import("@/views/tasks/new_task.vue");
const EditTask = () => import("@/views/tasks/edit_task.vue");
const Timesheets = () => import("@/views/timesheets/timesheets.vue");
const NewTimesheet = () => import("@/views/timesheets/new_timesheet.vue");
const EditTimesheet = () => import("@/views/timesheets/edit_timesheet.vue");

// settings
const ViewSettings = () => import("@/views/settings/settings.vue");
const PublicHoliday = () => import("@/views/settings/holiday.vue");
const TaskStatus = () => import("@/views/settings/task/task_status.vue");

// about
const ViewAbout = () => import("@/views/about/about.vue");

// help

const router = new Router({
	routes: [
		/* the route node will identify which part of the system we're in and determine where we are in our main navigation */
		{
			path: "/logon",
			component: NomenuContainer,
			children: [
				{ path: "/", name: "Logon", component: LogonForm },
				{ path: "upgrade", name: "Upgrade", component: Upgrade },
				{ path: "terms", name: "Terms", component: Terms },
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/desktop", // special desktop route for entry points for desktop UIs shown through oBrowser
			component: NomenuContainer,
			children: [
				{ path: "addressbook/:adbid/payroll_header_tab", name: "Payroll Header Tab", component: PayrollHeaderTab },
				{ path: "addressbook/:adbid/payroll_header", name: "New Payroll Header", component: NewPayrollHeader },
				{ path: "addressbook/:adbid/payroll_header/:pahid", name: "Edit Payroll Header", component: EditPayrollHeader },
				/** current_tab: 0-Timesheet, 1-Task, 2-Event, 3-Item, 4-Public Holiday, 5-Leave; new: only one tab */
				/**
				 * tasid -> Timesheet
				 * joid  -> Timesheet, Task, Event, Item
				 * adbid -> Timesheet, Event
				 * jpid  -> Task
				 * start_time  -> Timesheet, Task, Subtask, Event, Item, Public Holiday, format='YYYY-MM-DD HH:mm'(e.g., '2024-12-12 13:00')
				 * end_time    -> Timesheet, Subtask, format='YYYY-MM-DD HH:mm'(e.g., '2024-12-12 13:00')
				 * coid  -> Event
				 * clone -> timesheet
				 */
				{ path: "diary/:current_tab", name: "DiaryDialogue", component: DiaryDialogue, props: (route) => { adbid: route.query.adbid; joid:route.query.joid; coid: route.query.coid; tasid: route.query.tasid; start_time: route.query.start_time; end_time: route.query.end_time; jpid: route.query.jpid }},
				{ path: "diary/new/:current_tab", name: "DiaryNewDialogue", component: DiaryDialogue, props: (route) => { adbid: route.query.adbid; joid: route.query.joid; tasid: route.query.tasid; start_time: route.query.start_time; end_time: route.query.end_time; jpid: route.query.jpid }},
				/** evid: parent task id */
				{ path: "diary/new/subtask/:evid", name: "SubTaskDialog", component: SubTaskDialog, props: (route) => { start_time: route.query.start_time; end_time: route.query.end_time }},
				/** e.g., '/desktop/diary/event/343?iteration=1' */
				{ path: "diary/event/:evid", name: "EditEventDialogue", component: EditEventDialogue, props: (route) => { iteration: route.query.iteration }},
				{ path: "diary/holiday/:evid", name: "EditHolidayDialog", component: EditHolidayDialog, props: (route) => { iteration: route.query.iteration }},
				{ path: "diary/leave/:evid", name: "EditLeaveDialog", component: EditLeaveDialog},
				{ path: "diary/task/:evid", name: "EditTaskDialog", component: EditTaskDialog},
				/** edit timesheet => e.g., '/desktop/diary/timesheet/343'; copy timesheet => e.g., '/desktop/diary/timesheet/343?clone=true' */
				{ path: "diary/timesheet/:evid", name: "EditTimesheetDialog", component: EditTimesheetDialog, props: (route) => { clone: route.query.clone }},
				{ path: "diary/item/:evid", name: "EditItemDialog", component: EditItemDialog},
				/** testing, Media planner */
				{ path: "media/plan", name: "MediaPlan", component: MediaPlan, props: (route) => { joid:route.query.joid }},
				/** testing, Media planner */
				{ path: "media/hold", name: "MediaHolding", component: MediaRadioHolding},

				/** expenses */
				{ path: "expenses", name: "WebClaimCreate", component: WebClaim },
				/** evid: claim id */
				{ path: "webexpense/:evid", name: "WebClaimEdit", component: WebClaim },
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/",
			component: MenuContainer,
			children: [
				{ path: "/", name: "Dashboard", component: Dashboard },
			]
		},
		{
			path: "/expenses",
			component: MenuContainer,
			children: [
				{ path: "/expenses", name: "Expenses", component: Expenses },
				{ path: "claims", name: "Claims", component: Claims },
				{ path: "manager_review", name: "Manager Review", component: ManagerReview },
				{ path: "finance", name: "Finance", component: Finance },
				{ path: "claims/new_claim", name: "New Claim", component: NewClaim, props: (route) => ({ ids: route.query.ids }) },
				{ path: "claims/:id", name: "Edit Claim", component: EditClaim },
				{ path: "manager_review/:id", name: "Approve Claim", component: ApproveClaim },
				{ path: "finance/:id", name: "Finance Claim", component: FinanceClaim },
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/leave",
			component: MenuContainer,
			children: [
				{ path: "/leave", name: "Leave", component: Leave },
				{ path: "leave/:id", name: "Edit Leave", component: LeaveEdit },
				{ path: "leave", name: "Leave Calculator", component: LeaveCalculator },
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/jobs",
			component: MenuContainer,
			children: [
				{ path: "worklists", name: "Saved Job Worklists", component: SavedJobWorklists },
				{ path: "worklist/:id", name: "Job Worklist", component: JobWorklist },
				{ path: "search", name: "Search Jobs", component: SearchJobs },
				{ path: "create_new_job", name: "Create New Job", component: CreateNewJob },
				{ path: "job/:id", name: "View Job", component: Job },
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/addressbook",
			privilege: "AB",
			component: MenuContainer,
			children: [
				{ path: "worklists", name: "Saved Abook Worklists", component: SavedAbookWorklists },
				{ path: "worklist/:id", name: "Abook Worklist", component: AbookWorklist },
				{ path: "search", name: "Search Addressbook", component: SearchAddressbook },
				{ path: "entry/:id", name: "View Addressbook", component: Addressbook },
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/tasks",
			component: MenuContainer,
			children: [
				{ path: "tasklists", name: "Tasklists", component: SavedTasklist },
				{ path: "search", name: "Search Tasks", component: SearchTasks },
				{ path: "my_timesheets", name: "My Timesheets", component: MyTimesheets, props: (route) => ({ status: route.query.status })  },
				// { path: "tasklist/:id", name: "Tasklist", component: Tasklist },
				{ path: "tasklist/:id", name: "Tasks", component: Tasks },
				{ path: "new_task", name: "NewTask", component: NewTask },
				{ path: "/task/:id", name: "View Task", component: EditTask },
				{ path: "timesheets", name: "Timesheets", component: Timesheets },
				{ path: "new_timesheet", name: "New Timesheet", component: NewTimesheet },
				{ path: "timesheet/:id", name: "Edit Timesheet", component: EditTimesheet },
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/settings",
			component: MenuContainer,
			children: [
				{ path: "/settings", name: "View Settings", component: ViewSettings},
				{ path: "/settings/holiday", name: "Public Holiday", component: PublicHoliday},
				{ path: "/settings/taskstatuses", name: "Task Statuses", component: TaskStatus},
				{ path: "*", component: PageNotFound }
			]
		},
		{
			path: "/about",
			component: MenuContainer,
			children: [
				{ path: "/about", name: "View About", component: ViewAbout},
			]
		},
		{
			path: "/help",
			component: MenuContainer,
			children: [

			]
		},
	],
	mode: 'history'
});

router.beforeEach(function(to, from, next) {
	if (to.path == "/logon") {
		// JIC make sure we clear our token
		store.commit("clear_token");

		// and lets go
		next();
	}
	else if (to.path=="/help") {
		window.open("https://help.jobbag.com", "_blank");

	} else {
		// do we need to check the validity of the token?
		let check_token = false; // periodically set this to true

		// get our token
		let token = store.state.token;

		// need to find a way to move this code into our storage init
		if (token == 'init') {
			// console.log("init");

			if (localStorage.token) {
				// attempt to use this token
				store.commit("set_token", localStorage.token);
			} else {
				store.commit("clear_token");
			}

			// get our updated token...
			token = store.state.token;
			check_token = true;

			// console.log(token);
		}

		if (to.query.hasOwnProperty("token")) {
			// override with this property
			store.commit("set_token", to.query.token);

			// get our updated token...
			token = store.state.token;
			check_token = true;

			// console.log(token);
		}

		if (check_token) {
			store.dispatch('check_token');
		}

		if (to.path == "/logon/terms" || to.path == "/logon/logout") {
			// always allow terms and logout...
			next();
		} else if (to.path.startsWith("/desktop")) {
			// special routes for our desktop app, if we're not logged on it's the desktop apps responsibility to throw the user back to the logon screen
			next();
		} else if (token === "") {
			store.commit("set_redirect_after_logon", to.path);
			next("/logon");
		} else {
			next();
		}
	}
});

export default router;
